import { render, staticRenderFns } from "./OpenEnrollment.vue?vue&type=template&id=128146ff&"
import script from "./OpenEnrollment.vue?vue&type=script&lang=js&"
export * from "./OpenEnrollment.vue?vue&type=script&lang=js&"
import style0 from "./OpenEnrollment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports